import React, { useEffect, useRef } from "react";

const RatingWidget = () => {
	const elfsightScriptRef = useRef();
	const elfsightContainerRef = useRef();

	useEffect(() => {
		const elfsightScript = document.createElement("script");
		elfsightScript.src = "https://static.elfsight.com/platform/platform.js";
		elfsightScript.dataset.useServiceCore = true;
		elfsightScript.defer = true;

		elfsightScriptRef.current = elfsightScript;

		const elfsightContainer = elfsightContainerRef.current;

		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						// Load the script when the container comes into view
						document.body.appendChild(elfsightScriptRef.current);
						// Render the ElfSight widget
						window.elfsight && window.elfsight.init(elfsightContainer);
						// Disconnect the observer once the script is loaded
						observer.disconnect();
					}
				});
			},
			{ rootMargin: "300px" }
		); // You can adjust the margin as needed

		// Start observing the container
		observer.observe(elfsightContainer);

		// Cleanup function to disconnect the observer when component unmounts
		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<div
			ref={elfsightContainerRef}
			className="elfsight-app-0bf5ccd0-3a23-4479-9c72-67a7db48ce1f"
			data-elfsight-app-lazy
			style={{ marginTop: 24, minHeight: 127 }}
		></div>
	);
};

export default RatingWidget;
